import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import CheckoutForm from '../components/checkout/CheckoutForm';
import OrderSummary from '../components/checkout/OrderSummary';
import { Sparkles, ShieldCheck, ArrowLeft, ShoppingBag } from 'lucide-react';

const CheckoutPage = () => {
  const navigate = useNavigate();
  const { cart, getCartTotal } = useCart();
  const subtotal = getCartTotal();

  /* --- EMPTY CART REDIRECT / FALLBACK --- */
  if (!cart || cart.length === 0) {
    return (
      <main className="py-16 sm:py-24 max-w-xl mx-auto px-4 text-center bg-[#FDFBF7]">
        <div className="bg-[#FDFBF7] rounded-3xl p-8 sm:p-12 border border-[#E8DFC8] shadow-sm space-y-6">
          <div className="w-16 h-16 bg-[#F4EFE6] text-[#4A0E17] rounded-full flex items-center justify-center mx-auto border border-[#E8DFC8]">
            <ShoppingBag className="w-8 h-8" />
          </div>
          <div className="space-y-2">
            <h2 className="text-2xl font-serif font-bold text-[#4A0E17]">
              Your Shopping Bag is Empty
            </h2>
            <p className="text-xs text-[#544842] font-light leading-relaxed">
              Please add items from our silk saree or jewelry collections before proceeding to checkout.
            </p>
          </div>
          <button
            onClick={() => navigate('/catalog')}
            className="inline-flex items-center space-x-2 bg-[#4A0E17] hover:bg-[#6B1320] text-[#FDFBF7] text-xs font-serif font-bold uppercase tracking-wider px-8 py-3.5 rounded-2xl transition-all shadow-md active:scale-95 border border-[#6B1320]"
          >
            <span>Return to Catalog</span>
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="py-6 sm:py-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-[#FDFBF7]">
      
      {/* Header & Back Link */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 pb-6 border-b border-[#E8DFC8]">
        <div>
          <div className="flex items-center space-x-2 mb-1">
            <Sparkles className="w-3.5 h-3.5 text-[#4A0E17]" />
            <span className="text-[10px] font-serif font-bold tracking-[0.25em] text-[#4A0E17] uppercase">
              Secure Concierge Checkout
            </span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-[#4A0E17]">
            Complete Your Order
          </h1>
        </div>

        <Link
          to="/cart"
          className="inline-flex items-center space-x-2 text-xs font-serif font-bold text-[#4A0E17] hover:text-[#6B1320] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Shopping Bag</span>
        </Link>
      </div>

      {/* Main Grid: Form + Summary */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        
        {/* Left Column: Delivery & Payment Details */}
        <div className="lg:col-span-7 bg-[#FDFBF7] rounded-3xl p-6 sm:p-8 border border-[#E8DFC8] shadow-sm">
          <CheckoutForm cartItems={cart} totalPrice={subtotal} />
        </div>

        {/* Right Column: Order Summary Side Panel */}
        <div className="lg:col-span-5 space-y-6 lg:sticky lg:top-24">
          <div className="bg-[#FDFBF7] rounded-3xl p-6 border border-[#E8DFC8] shadow-sm">
            <OrderSummary cartItems={cart} total={subtotal} />
          </div>

          {/* Trust Badge Card */}
          <div className="bg-[#F4EFE6] rounded-2xl p-4 border border-[#E8DFC8] flex items-center space-x-3 text-xs text-[#7A6B5D]">
            <ShieldCheck className="w-6 h-6 text-[#4A0E17] shrink-0" />
            <p className="leading-relaxed">
              Every creation is shipped in insured luxury packaging with certified silk/authenticity hallmarks.
            </p>
          </div>
        </div>

      </div>
    </main>
  );
};

export default CheckoutPage;